import axios from 'axios'
import { BUSCAR_USUARIO_POR_PARTE } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER } from '../../util/responseUtil'
import { URL } from '../../util/ambienteActions';

const OFFLINE_AWARE_CONFIG = {
  headers: {
    ...SLOW_REQUEST_CONFIG.headers,
    [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
  }
}

export default function buscarUsuarioPorEmpresaNomeIdEmail (nome, empresaId) {
    const url = `${URL}/usuarios/${nome}/empresa/${empresaId}`;
  return dispatch => axios.get(url, OFFLINE_AWARE_CONFIG).then(
      response => dispatch({
          type: BUSCAR_USUARIO_POR_PARTE,
        payload: response

      })
  ).catch(erro => {
    if (!navigator.onLine || !erro.response) {
      return dispatch({ type: BUSCAR_USUARIO_POR_PARTE, payload: { data: [] } });
    }
    throw erro;
  });
}
